import axios from 'axios';

export default async function checkBlacklist(
  cpfCnpj: string,
): Promise<{ isBlacklisted: boolean; message: string }> {
  const response = await axios.post(
    `${process.env.REACT_APP_OG_API_URL}/blacklist/check`,
    { cpfCnpj: cpfCnpj.replace(/[^\d]+/g, '') },
  );
  if (response.data.isBlacklisted) {
    return {
      isBlacklisted: true,
      message:
        'Houve um problema ao realizar a operação. Por favor, entre em contato conosco pelo número (61) 4007-2028 para podermos ajudar.',
    };
  }
  return { isBlacklisted: false, message: '' };
}
